// /app/frontend/src/config/pricing.js
// Central pricing configuration — single source of truth for the paywall.
// All gate logic across the app reads from this file.

// ──────────────────────────────────────────────────────────────────────────
// Paywall date — controlled by three constants.
//
// To move the paywall, A NON-DEVELOPER ONLY NEEDS TO CHANGE `PAYWALL_DAY`.
// Set it to the day of the month the paywall should go live. Increase the
// number to push the paywall later; decrease to flip it on sooner. The other
// two constants (year / month) only change if you cross a month/year boundary.
//
// Notes:
//  • PAYWALL_MONTH is **0-indexed** (Jan = 0, Feb = 1, … Jul = 6, Dec = 11).
//  • The comparison runs at midnight IST (UTC+5:30).
// ──────────────────────────────────────────────────────────────────────────
export const PAYWALL_YEAR  = 2026;
export const PAYWALL_MONTH = 9; // 0-indexed → 9 = October
export const PAYWALL_DAY   = 31; // ← change ONLY this to move the date

// Midnight IST = 00:00 UTC+5:30 ≡ 18:30 UTC the previous day.
export const PAYWALL_DATE = new Date(Date.UTC(
  PAYWALL_YEAR,
  PAYWALL_MONTH,
  PAYWALL_DAY - 1, // back one day because we subtract 5:30 below
  18, 30, 0,
));

export const isPricingLive = () => new Date() >= PAYWALL_DATE;

export const GATED_ROUTES = [
  '/advisor',
  '/financial',
  '/decision-report',
];

export const PARTIAL_ROUTES = {
  '/top-picks': { freeLimit: 3 },
  '/compare':   { freeLimit: 2 },
};
